(() => {
  const moveUsdaBadgeBelowPurchaseBlock = () => {
    const usdaBadge = document.querySelector('.usda-organic-pdp-badge');
    const submitButton = document.querySelector('[id^="ProductSubmitButton-"]');
    const productInfo = document.querySelector('.product__info-container');

    if (!usdaBadge || !submitButton || !productInfo) return;

    let purchaseBlock = submitButton;
    while (purchaseBlock.parentElement && purchaseBlock.parentElement !== productInfo) {
      purchaseBlock = purchaseBlock.parentElement;
    }

    if (purchaseBlock.parentElement !== productInfo || purchaseBlock.nextElementSibling === usdaBadge) return;

    purchaseBlock.insertAdjacentElement('afterend', usdaBadge);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveUsdaBadgeBelowPurchaseBlock, { once: true });
  } else {
    moveUsdaBadgeBelowPurchaseBlock();
  }

  window.setTimeout(moveUsdaBadgeBelowPurchaseBlock, 500);
})();

if (!customElements.get('mobile-sticky-atc')) {
  customElements.define(
    'mobile-sticky-atc',
    class MobileStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.updateVisibility.bind(this);
        this.onResize = this.updateVisibility.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onBundleChange = this.updateBundleContext.bind(this);
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mainButtonObserver = null;
        this.bundleObserver = null;
      }

      connectedCallback() {
        this.button = this.querySelector('[data-mobile-sticky-atc-button]');
        this.buttonText = this.querySelector('[data-mobile-sticky-button-text]');
        this.titleEl = this.querySelector('[data-mobile-sticky-title]');
        this.priceEl = this.querySelector('[data-mobile-sticky-price]');

        if (!this.button) return;

        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.mobileQuery.addEventListener?.('change', this.onResize);

        this.bindMainButton();
        this.bindBundleWidget();
        this.updateBundleContext();
        this.syncButtonState();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.mobileQuery.removeEventListener?.('change', this.onResize);
        this.mainButtonObserver?.disconnect();
        this.bundleObserver?.disconnect();
        document.body.classList.remove('mobile-sticky-atc-visible');
      }

      bindMainButton() {
        const mainButton = this.mainButton;
        if (!mainButton) return;

        this.mainButtonObserver?.disconnect();
        this.mainButtonObserver = new MutationObserver(() => this.syncButtonState());
        this.mainButtonObserver.observe(mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      bindBundleWidget() {
        const bundleWidget = document.querySelector(this.dataset.bundleSelector);
        if (!bundleWidget) {
          window.setTimeout(() => this.bindBundleWidget(), 500);
          return;
        }

        bundleWidget.addEventListener('click', this.onBundleChange);
        bundleWidget.addEventListener('change', this.onBundleChange);

        this.bundleObserver?.disconnect();
        this.bundleObserver = new MutationObserver(this.onBundleChange);
        this.bundleObserver.observe(bundleWidget, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'style', 'aria-checked', 'aria-selected'],
        });
        this.updateBundleContext();
      }

      updateBundleContext() {
        window.requestAnimationFrame(() => {
          const selectedBundle = document.querySelector(
            '.kaching-bundles__bar--selected, .kaching-bundles__bar[aria-checked="true"], .kaching-bundles__bar[aria-selected="true"]'
          );
          if (!selectedBundle) return;

          const bundleTitle = this.cleanText(
            selectedBundle.querySelector('.kaching-bundles__bar-title, .kaching-bundles__bar-label')?.textContent
          );
          const bundlePrice = this.cleanText(
            selectedBundle.querySelector('.kaching-bundles__bar-price, .kaching-bundles__bar-full-price')?.textContent
          );

          if (bundleTitle && this.titleEl) this.titleEl.textContent = bundleTitle;
          if (bundlePrice && this.priceEl) this.priceEl.textContent = bundlePrice;
        });
      }

      updateVisibility() {
        if (!this.mobileQuery.matches || this.overlayIsOpen()) {
          this.setVisible(false);
          return;
        }

        const mainButton = this.mainButton;
        if (!mainButton) {
          this.setVisible(window.scrollY > 300);
          return;
        }

        const rect = mainButton.getBoundingClientRect();
        const buttonIsVisible = rect.top < window.innerHeight - 88 && rect.bottom > 72;
        this.setVisible(!buttonIsVisible && window.scrollY > 120);
      }

      syncButtonState() {
        const mainButton = this.mainButton;
        if (!mainButton || !this.button) return;

        const isDisabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        const isLoading = mainButton.classList.contains('loading');
        const mainButtonText = this.cleanText(mainButton.querySelector('span')?.textContent || mainButton.textContent);

        this.button.disabled = isDisabled;
        this.button.classList.toggle('is-loading', isLoading);
        if (this.buttonText && mainButtonText && !isLoading) {
          this.buttonText.textContent = mainButtonText;
        } else if (this.buttonText && isLoading) {
          this.buttonText.textContent = 'Adding...';
        }
      }

      handleClick() {
        const mainButton = this.mainButton;
        if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') {
          this.scrollToPurchaseOptions();
          return;
        }

        this.button?.classList.add('is-loading');
        if (this.buttonText) this.buttonText.textContent = 'Adding...';
        mainButton.click();
        window.setTimeout(() => this.syncButtonState(), 1200);
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        document.body.classList.toggle('mobile-sticky-atc-visible', visible);
      }

      scrollToPurchaseOptions() {
        const target = document.querySelector(this.dataset.bundleSelector) || document.getElementById(this.dataset.productInfoId);
        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      overlayIsOpen() {
        return [
          'mini-cart--open',
          'mini-cart--opening',
          'menu-drawer--open',
          'menu-drawer--opening',
          'menu-mobile--open',
          'menu-mobile--opening',
          'search-modal--open',
          'quick-view--open',
          'quick-view--opening',
        ].some((className) => document.body.classList.contains(className));
      }

      cleanText(value) {
        return value ? value.replace(/\s+/g, ' ').trim() : '';
      }

      get mainButton() {
        return document.querySelector(this.dataset.mainSubmitSelector);
      }
    }
  );
}
